import * as Sentry from '@sentry/nextjs';

export function setSentryUserFromSession(user?: {
  id?: number;
  email?: string;
  firstName?: string;
  lastName?: string | null;
}) {
  if (!user) return;

  Sentry.setUser({
    id: user.id || undefined,
    email: user.email || undefined,
    username: `${user.firstName} ${user.lastName}` || undefined,
  });
}
